export default {"src":"/_next/static/media/timer_logo.075a3381.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};